import '@computerrock/react-app-polyfill/ie11';
import '@computerrock/react-app-polyfill/stable';
import React, {useState, useEffect} from 'react';
import * as ReactDOMClient from 'react-dom/client';
import PropTypes from 'prop-types';
import {createBrowserHistory, renderRoutes} from '@computerrock/formation-router';
import {FormationApp, configureStore, serviceWorker} from '@computerrock/formation-core';
import {FileAssetsProvider} from '@ace-de/eua-file-assets';
import './application/initDynamicEnv';
import config from './config';
import getRoutes from './routes';
import modals from './modals';
import sagas from './saga';
import serviceManager from './ServiceManager';
import routePaths from './routePaths';
import reducers from './reducer';

// initialize history
const history = createBrowserHistory({basename: config.PUBLIC_URL});

// initialize store
const store = configureStore({
    routes: getRoutes(),
    history,
    reducers,
    serviceManager,
});
store.runSagas(sagas);

// load i18nService
const i18nService = serviceManager.loadService('i18nService');

// Application
const Application = ({store, history}) => {
    const [routes, setRoutes] = useState(getRoutes());

    useEffect(() => {
        return window.DYNAMIC_ENV.onEnvChange((property, value) => {
            if (property === 'IS_MAINTENANCE_MODE_ON') {
                setRoutes(getRoutes());
                console.log(`Dynamic ENV update: ${property}=${value}`); // eslint-disable-line no-console
            }
        });
    }, []);

    return (
        <FormationApp
            store={store}
            history={history}
            modals={modals}
            routes={routes}
            routePaths={routePaths}
            defaultRoutePath={routePaths.DASHBOARD}
            i18nService={i18nService}
            render={({children}) => (
                <FileAssetsProvider>
                    {children}
                </FileAssetsProvider>
            )}
        >
            {renderRoutes(routes)}
        </FormationApp>
    );
};

Application.propTypes = {
    store: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
};

// render application
const root = ReactDOMClient.createRoot(document.getElementById('root'));
root.render(<Application store={store} history={history} />);

// webpack hot module replacement for ./routes configuration,
// ./saga configuration and state is not hot reloaded but needs to
// be accepted so HMR can work properly
if (module.hot) {
    module.hot.accept(['./routes', './saga'], () => {
        root.render(<Application store={store} history={history} />);
    });
}

// register service worker
serviceWorker.register({
    onUpdate: () => {
        // reload on new content
        window.location.reload();
    },
});
